var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',_vm._g(_vm._b({class:( _obj = {}, _obj[_vm.$style.input] = true, _obj[_vm.$style.checked] = _vm.checked, _obj ),attrs:{"type":_vm.type},domProps:{"checked":_vm.checked}},'input',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }